(function () {
  'use strict';

  const TRIGGER_VARIANT_ID = '54426375225690';
  const ADDON_VARIANT_ID = '54985449505114';
  const ADDON_QUANTITY = 1;

  let isAddingAddon = false;
  let queuedCheck = false;
  let lastAddFailureAt = 0;
  const ADD_FAILURE_RETRY_DELAY = 30000;

  function getRoutes() {
    return (window.FoxThemeSettings && window.FoxThemeSettings.routes) || {};
  }

  function getCartAddPath() {
    const routes = getRoutes();
    return new URL(routes.cart_add_url || '/cart/add.js', window.location.origin).pathname;
  }

  function getCartJsonUrl() {
    const routes = getRoutes();
    const cartUrl = routes.cart || '/cart';
    return `${cartUrl.replace(/\/$/, '')}.js`;
  }

  function isVariantInCart(cart, variantId) {
    if (!cart || !Array.isArray(cart.items)) return false;

    return cart.items.some((item) => {
      return String(item.id) === variantId || String(item.variant_id) === variantId;
    });
  }

  function collectCartSections() {
    let sections = [];

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', {
        bubbles: true,
        detail: { sections },
      })
    );

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      sections = [
        ...sections,
        ...cartDrawer.getSectionsToRender().map((section) => section.id),
      ];
    }

    const mainCart = document.querySelector('cart-items');
    if (mainCart && typeof mainCart.getSectionsToRender === 'function') {
      sections = [
        ...sections,
        ...mainCart.getSectionsToRender().map((section) => section.section || section.id),
      ];
    }

    return [...new Set(sections.filter(Boolean))];
  }

  async function fetchCart() {
    const response = await fetch(getCartJsonUrl(), {
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    if (!response.ok) {
      throw new Error(`Unable to read cart: ${response.status}`);
    }

    return response.json();
  }

  function refreshCartUi(state) {
    const pubSubEvents = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;

    if (window.FoxThemeEvents && pubSubEvents && pubSubEvents.cartUpdate && state && state.sections) {
      window.FoxThemeEvents.emit(pubSubEvents.cartUpdate, state);
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
    }

    if (
      window.FoxThemeCartHelpers &&
      typeof window.FoxThemeCartHelpers.getState === 'function' &&
      typeof window.FoxThemeCartHelpers.updateCartCount === 'function'
    ) {
      window.FoxThemeCartHelpers.getState().then((cart) => {
        if (cart) window.FoxThemeCartHelpers.updateCartCount(cart.item_count);
      });
    }
  }

  async function addAddonToCart() {
    if (Date.now() - lastAddFailureAt < ADD_FAILURE_RETRY_DELAY) {
      return { skipped: true, reason: 'recent_failure' };
    }

    const routes = getRoutes();
    const formData = new FormData();
    const sections = collectCartSections();

    formData.append('id', ADDON_VARIANT_ID);
    formData.append('quantity', ADDON_QUANTITY);

    if (sections.length > 0) {
      formData.append('sections', sections.join(','));
      formData.append('sections_url', window.location.pathname);
    }

    isAddingAddon = true;

    try {
      const response = await fetch(routes.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });
      const state = await response.json();

      if (!response.ok || state.status) {
        lastAddFailureAt = Date.now();
        throw new Error(state.description || state.message || `Unable to add automatic cart item: ${response.status}`);
      }

      lastAddFailureAt = 0;
      refreshCartUi(state);
      return state;
    } finally {
      isAddingAddon = false;
    }
  }

  async function ensureAddonInCart() {
    if (isAddingAddon) return;

    try {
      const cart = await fetchCart();
      const hasTrigger = isVariantInCart(cart, TRIGGER_VARIANT_ID);
      const hasAddon = isVariantInCart(cart, ADDON_VARIANT_ID);
      const result = {
        triggerVariantId: TRIGGER_VARIANT_ID,
        addonVariantId: ADDON_VARIANT_ID,
        hasTrigger,
        hasAddon,
        added: false,
        cartVariantIds: cart.items.map((item) => String(item.variant_id || item.id)),
      };

      if (hasTrigger && !hasAddon) {
        const addResult = await addAddonToCart();
        result.added = !!(addResult && !addResult.skipped);
        result.addResult = addResult;
      }

      return result;
    } catch (error) {
      console.warn('Primavera auto-add cart rule failed:', error);
      return {
        triggerVariantId: TRIGGER_VARIANT_ID,
        addonVariantId: ADDON_VARIANT_ID,
        error: error.message,
      };
    }
  }

  function queueCartCheck(delay = 250) {
    if (queuedCheck) return;

    queuedCheck = true;
    window.setTimeout(() => {
      queuedCheck = false;
      ensureAddonInCart();
    }, delay);
  }

  function isCartAddRequest(input) {
    const requestUrl = typeof input === 'string' ? input : input && input.url;
    if (!requestUrl) return false;

    try {
      const path = new URL(requestUrl, window.location.origin).pathname;
      return path === getCartAddPath() || path.endsWith('/cart/add.js');
    } catch (error) {
      return false;
    }
  }

  function patchFetch() {
    if (!window.fetch || window.fetch.__primaveraAutoAddPatched) return;

    const originalFetch = window.fetch;

    window.fetch = function primaveraAutoAddFetch(input, init) {
      const isCartAdd = isCartAddRequest(input);

      return originalFetch.apply(this, arguments).then((response) => {
        if (isCartAdd && !isAddingAddon) {
          queueCartCheck(150);
        }

        return response;
      });
    };

    window.fetch.__primaveraAutoAddPatched = true;
  }

  patchFetch();
  document.addEventListener('product-ajax:added', () => queueCartCheck(150));
  document.addEventListener('cart:updated', () => queueCartCheck(250));
  document.addEventListener('cart:refresh', () => queueCartCheck(500));

  const pubSubEvents = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;
  if (window.FoxThemeEvents && pubSubEvents && pubSubEvents.cartUpdate) {
    window.FoxThemeEvents.subscribe(pubSubEvents.cartUpdate, () => queueCartCheck(250));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => queueCartCheck(500));
  } else {
    queueCartCheck(500);
  }

  window.PrimaveraAutoAdd = {
    check: ensureAddonInCart,
    debug: () => ensureAddonInCart().then((result) => {
      console.log('Primavera auto-add:', result);
      return result;
    }),
    cart: fetchCart,
    triggerVariantId: TRIGGER_VARIANT_ID,
    addonVariantId: ADDON_VARIANT_ID,
  };
})();
